import React from 'react';
import Modal from 'react-responsive-modal';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
const log = new Logger('ANALYSIS_DETAILS_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height modal-max-width-85'
};

class AnalysisDetailsModal extends React.Component {

    constructor(props) {
        super(props);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    onCloseClick(event) {
        log.debug('onCloseClick(): event: ', event);
        this.props.onCloseClick();
    }

    render() {
        log.debug('render(): ', this.props);
        const {open} = this.props;
        return (
            <div>
                <Modal center
                    classNames={MODAL_CLASSNAMES}
                    open={open}
                    closeOnOverlayClick={false}
                    onClose={this.onCloseClick}
                >
                    {this.props.titleLanguageString ? (<h2><LanguageStringResolver string={this.props.titleLanguageString} /></h2>) : ('')}
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}


AnalysisDetailsModal.defaultProps = {
    open: false,
    onCloseClick: () => {},
    titleLanguageString: ''
}

export default AnalysisDetailsModal;
